
import { defineComponent } from 'vue'
import { EpbButton } from '../shared/epb-button'
import { EpbText } from '../shared/epb-text'

export default defineComponent({
  name: 'ToolingEmptyList',
  components: {
    EpbText,
    EpbButton,
  },
  props: {
    emptyListText: {
      type: String,
      required: true,
    },
    setupText: {
      type: String,
      required: true,
    },
  },
  setup() {
    return {
      baseClass: 'epb-tooling-empty-list',
    }
  },
})
